package br.com.texeratx.boardgametimeapp.core.spotify.storage

import kotlinx.serialization.Serializable

@Serializable
data class SpotifyTokens(
    val accessToken: String,
    val refreshToken: String?,
    val expiresAtEpochSec: Long,
    val scope: Set<String>
)

@Serializable
data class SpotifyEphemeral(
    val state: String,
    val codeVerifier: String
)

interface SpotifyStorage {
    fun saveEphemeral(value: SpotifyEphemeral)
    fun readEphemeral(): SpotifyEphemeral?
    fun clearEphemeral()

    fun saveTokens(tokens: SpotifyTokens)
    fun readTokens(): SpotifyTokens?
    fun clearTokens()
}
